import { api } from './api'

/** A financial request has one destination and is never retried implicitly. */
export function fetchOfferApi(path: string, init?: RequestInit): Promise<Response> {
  const endpoint = path.replace(/^\/api\/v2\//, '/')
  return fetch(`${api.defaults.baseURL?.replace(/\/$/, '')}${endpoint}`, init)
}
